import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class OnboardingRoute extends Route {
	@service('account') declare accountService: Service.Account;
	@service('billing') declare billingService: Service.Billing;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('onboarding') declare onboardingService: Service.Onboarding;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('request') declare requestService: Service.Request;
	@service('model-manager/teams') declare mmTeamsService: Service.ModelManager.Teams;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'page-onboarding';

		const promises: Promise<unknown>[] = [this.navigationService.initialRequestsPromise];
		promises.push(this.mmMetricsService.requestMetrics());
		promises.push(this.mmTemplatesService.requestBoardPublicTemplates());

		if (this.onboardingService.templateId) {
			promises.push(this.mmTemplatesService.requestReportPublicTemplates());
		}

		return Promise.all(promises);
	}

	override afterModel(): void {
		if (this.currentUserService.isOnboarded) {
			this.navigationService.transitionToRoute('index');
			return;
		}

		if (this.onboardingService.templateId) {
			const sourceTypesKeys =
				this.onboardingService.publicTemplate?.specificSourceTypesKeys || [];

			// to show integrations in recommended section for template onboarding flow
			if (sourceTypesKeys.length > 0) {
				void this.accountService.saveMetadataProperties({
					sourcesSelection: sourceTypesKeys,
				});
			}
		}

		const preventTriggeringSecondTrialAfterExpiredTrial =
			this.currentUserService.hasSpecialPermissions ||
			this.accountService.hasPartnerResellerId ||
			!this.currentUserService.isAdmin;

		if (
			this.billingService.isExpiredTrial &&
			!this.currentUserService.isOnboarded &&
			!preventTriggeringSecondTrialAfterExpiredTrial
		) {
			const trialCount = this.billingService.trialCount;

			if (trialCount === 1) {
				this.requestService
					.api('POST', '/account/secondtrial')
					.catch(this.requestService.showAllValidationErrors.bind(this.requestService));
			} else if (trialCount === 2) {
				this.onboardingService.markCompleted();
				this.navigationService.transitionToRoute('index');
			}
		}
	}
}
